// extracted by mini-css-extract-plugin
export default {"column":"styles_column__Nj+Dl","fileIcon":"styles_fileIcon__n3P0F","ant-tabs-nav":"styles_ant-tabs-nav__yXJTh","ant-pro-card":"styles_ant-pro-card__OAJjq"};